import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonDataService } from '../../appDataServices/commonDataService';
import { StringConstants } from '../../_constants/stringConstants';
import { AuthenticationService, UtilityService, DataService } from '../../_services';
import { AppConfigService } from '../../_services/appConfigService';
import { CommonService } from '../../_services/common.service';
import { DateUtilsService } from '../../_services/dateUtils';
import { FilterService } from '../../_services/filter.service';
import { AppStateService } from '../../_services/state.service';
import { Config } from '../../_store/config';
import { InvoiceService } from '../invoice.service';
import { PayService } from '../pay.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceManualKnockOffService {

  // private selectionRecommended: string = this.translate.instant('MESSAGES.SELECTION_RECOMMENDED')

  constructor(
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private dataService: DataService,
    private appStateService: AppStateService,
    private invoiceService: InvoiceService,
    private payService: PayService,
    private dateUtils: DateUtilsService,
    private commonDataService: CommonDataService,
    private translate: TranslateService
  ) {
  }

  getInvoicesForPayment(paymentData) {
    console.log(paymentData);
    
    const getResponse = (invoiceData, paymentData) => {
      const todayDate = this.dateUtils.getToday();
      const receivedInvoices = Object.keys(invoiceData.invoices);
      const invoices = receivedInvoices.map(invDocId => {
        const invoice = invoiceData.invoices[invDocId];
        const sellerConfig = invoiceData.sellerConfig[invoice.sellerCode];
        this.invoiceService.enhanceSingleInvoice(invoice, sellerConfig, todayDate);
        invoice.isVisible = true;
        return invoice;
      });
      const retData = {
        paymentData: paymentData,
        payModel: {},
        invoiceData: {
          docIds: invoices.map(item => item.docId),
          invoice: invoices[0],
          PP: false,
          currCode: invoices[0].currCode
        },
        creditNotes: [],
        invoices: [],
        hideBankAmt: true,
        loadingCreditNotes: false,
        selectedCreditNotesAmount: 0,
        clearCreditNotesSelection: () => {
          retData.creditNotes.forEach(item => {
            item.selected = false;
          });
          this.processInvoiceSelectionForPayment(retData);
        },
        checkCreditNotesToBeDisabled: () => {
          this.processInvoiceSelectionForPayment(retData);
        },
        getPayableAmount: () => {
          this.processInvoiceSelectionForPayment(retData);
        },
        setCreditNotes: (crnList) => {
          retData.creditNotes = crnList;
        },
        setLoadingCreditNotes: (loading) => {
          retData.loadingCreditNotes = loading;
        },
        clearSelection: () => {
          retData.clearCreditNotesSelection();
          retData.invoices.forEach(item => {
            item.selected = false;
          })
        }
      };
      return Object.assign(retData, {
        invoices,
        paymentDetails: invoiceData.paymentDetails
      })
    }
    return this.commonDataService.getData(paymentData, 'GET_INVOICES_FOR_MANUAL_KNOCKOFF', true).pipe(map(invoiceData => {
      return getResponse(invoiceData.data, paymentData);
    }));
  }

  processInvoiceSelectionForPayment(knockOffData) {
    const totalAmount = knockOffData.paymentDetails.amount;
    const selectedInvoices = knockOffData.invoices.filter(item => item.selected);
    const selectedCreditNotes = (knockOffData.creditNotes || []).filter(item => item.selected);
    knockOffData.selectedInvoicesCount = selectedInvoices.length;
    knockOffData.selectedCreditNotesAmount = selectedCreditNotes.reduce((total, item) => {
      return total + item.amount;
    }, 0);
    knockOffData.selectedInvoicesAmount = selectedInvoices.reduce((total, item) => {
      return total + item.dueAmt;
    }, 0) - knockOffData.selectedCreditNotesAmount;
    knockOffData.advanceAmount = totalAmount - (knockOffData.selectedInvoicesAmount);
    if (knockOffData.selectedInvoicesCount) {
      knockOffData.invoiceData.selectedInvoices = selectedInvoices.map(item => item.docId);
    } else {
      knockOffData.invoiceData.selectedInvoices = [];
    }
    knockOffData.invoices.forEach(item => {
      item.selectionDisabled = !item.selected && (item.dueAmt > knockOffData.advanceAmount);
    });
    knockOffData.creditNotes.forEach(item => {
      item.disabled = !item.selected && (item.amount > knockOffData.totalAmount);
    });
    // Safe guard
    if (knockOffData.selectedInvoicesAmount < 0 || knockOffData.advanceAmount < 0 || !knockOffData.selectedInvoicesAmount) {
      knockOffData.invalidSelection = true;
    } else {
      knockOffData.invalidSelection = false;
    }
  }

  getManualKnockoffSelectionMessage(knockOffData) {
    console.log(knockOffData);
    
    let retMsg = '';
    // const notSelectedInvoices = knockOffData.invoices.filter(item => (!item.selected && item.dueAmt < knockOffData.advanceAmount));
    // if (notSelectedInvoices.length) {
    //   retMsg = `${this.translate.instant('MESSAGES.SELECTION_RECOMMENDED')} ${this.dataService.ellipsifyMsg(notSelectedInvoices.map(item => item.docNo).join(', '), 50)}.`
    // }
    return retMsg;
  }

  doManualKnockOff(manualKnockoffData, payexPin) {
    console.log(manualKnockoffData);
    
    const selectedInvoices = manualKnockoffData.invoices.filter(item => item.selected);
    const selectedCreditNotes = (manualKnockoffData.creditNotes || []).filter(item => item.selected);
    const paymentData: any = manualKnockoffData.paymentData;
    const req = {
      // buyerCode: paymentData.buyerCode,
      // sellerCode: paymentData.sellerCode,
      // docIds: selectedInvoices.map(item => item.docId),
      docIds: selectedInvoices.map(item => {
        return Object.assign({}, item, {
          docId: item.docId,
          buyerCode: item.buyerCode,
          amt: item.docAmt,
        })
      }),
      cnsSelected: selectedCreditNotes.map(item => {
        return Object.assign({}, item, {
          cnId: item.docId,
          cnAmt: item.docAmt,
          docRef: item.docRef,
          cnRef: item.docRef,
          cnNo: item.docNo
        })
      }),
      tpin: payexPin,
      paymentId: manualKnockoffData.paymentDetails.utrNo,
      utrNo: manualKnockoffData.paymentDetails.utrNo,
      utr: manualKnockoffData.paymentDetails.utrNo,
      payDate: this.dateUtils.getTimeStampFromMomentForPayments(this.dateUtils.getToday()),
      remarks: "",
      payAmt: manualKnockoffData.selectedInvoicesAmount + (manualKnockoffData.selectedCreditNotesAmount || 0),
      advanceAmt: manualKnockoffData.advanceAmount,
      multiBuyer:true,
    }
    return this.commonDataService.getData(req, 'PROCESS_MANUAL_KNOCKOFF').pipe(map(data => {
      return data;
    }));
  }

  getManualKnockOffLandingData() {
    const modeConfig = Config.landingPageRouteConfig['knock-off'];
    return this.appStateService.getAppStateAttribute(modeConfig.landingStateKey || StringConstants.LANDING_STATE);
  }

  clearManualKnockoffLandingData() {
    const modeConfig = Config.landingPageRouteConfig['knock-off'];
    return this.appStateService.clearLandingState(modeConfig.landingStateKey || StringConstants.LANDING_STATE);
  }

  getRTRLink(req) {
    return this.commonDataService.getData(req, 'RTR_LINK').pipe(map(data => {
      data.data.forEach(linkItem => {
        linkItem.routeUrl = linkItem.url.substring(linkItem.url.indexOf('landing/'));

        //the timestamp is in Milliseconds
        var rtrActivateTime = (linkItem.reqActivateTime / 1000);

        const invDueDateMoment = this.dateUtils.getDisplayDateFromTimestamp(rtrActivateTime);
        linkItem.rtrDate = this.dateUtils.getFormattedDateForDisplay(invDueDateMoment);

        linkItem.formattedAmount = this.dataService.displayNumberAsCurrency(linkItem.amt);
      });
      return data;
    }));
  }


}

